import React from "react";
import { useNavigate } from "react-router-dom";

const ExternalEmergencyPreparednessDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="px-2 py-4 mt-14 w-full h-full">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-4">
          External Emergency Preparedness Dashboard
        </h1>
        <p className="text-gray-600 mb-6">
          This is External Emergency Preparedness module.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <button
            type="button"
            onClick={() => navigate("/external-emergency-preparedness/incidents")}
            className="flex items-center gap-3 p-4 rounded-lg border-2 border-gray-200 hover:border-[#0fa9a6] hover:bg-[#f0fdfc] text-left transition-colors"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#0fa9a6]/10 text-[#0fa9a6] font-semibold">
              IM
            </span>
            <div>
              <span className="font-semibold text-gray-900">Incidents</span>
              <p className="text-sm text-gray-500">View and manage external emergency incidents</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExternalEmergencyPreparednessDashboard;

